import axios from '@/axios';
import store from '@/store';

import auth from '@/auth/service';

// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export default {
  init(router) {
    console.log('JWT:init');
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        // const { config, response: { status } } = error
        const { config, response } = error;
        const originalRequest = config;

        // Om det är en refresh som skiter sig finns bara en sak kvar att göra.
        // Logga in på nytt
        if (config.url === '/vi/auth/refresh') {
          isAlreadyFetchingAccessToken = false;
          store.commit('auth/LOGOUT_USER');
          router.push({
            name: 'login'
          });
          return;
        }

        // if (status === 401) {
        if (
          response &&
          response.status === 401 &&
          config.url !== '/v1/auth/login'
        ) {
          console.log('INTERCEPTOR: 401');
          if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            store
              .dispatch('auth/fetchAccessToken')
              .then(access_token => {
                isAlreadyFetchingAccessToken = false;
                onAccessTokenFetched(access_token);
              })
              .catch(error => {
                store.commit('auth/LOGOUT_USER');
                router.push({
                  name: 'login'
                });
                return;
              });
          }

          const retryOriginalRequest = new Promise(resolve => {
            addSubscriber(access_token => {
              originalRequest.headers.Authorization = 'Bearer ' + access_token;
              resolve(axios(originalRequest));
            });
          });
          return retryOriginalRequest;
        }

        return Promise.reject(error);
      }
    );
  },
  login(email, pwd) {
    return axios.post('/auth/local', { identifier: email, password: pwd });
  },
  me(token) {
    return axios.get('/v1/auth/me');
  },
  registerUser(name, email, pwd) {
    return axios.post('/v1/auth/register', {
      displayName: name,
      email: email,
      password: pwd
    });
  },
  refreshToken() {
    if (!localStorage.getItem(auth.tokenKey())) {
      return Promise.reject('Token is missing');
    }

    return axios.post('/v1/auth/refresh');
  }
};
